
export const trackTwitterEvent = (eventId: string, parameters = {}) => {
  if (typeof window.twq !== 'undefined') {
    window.twq('event', eventId, parameters);
  }
};

/**
 * Track a Google Ads conversion
 * @param conversionId - The conversion ID (e.g., 'AW-17079127763')
 * @param conversionLabel - The conversion label for the specific action
 * @param params - Additional parameters to send with the conversion
 */
export const trackGoogleAdsConversion = (conversionLabel: string, params = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      send_to: `AW-17079127763/${conversionLabel}`,
      ...params
    });
    console.log(`Tracked Google Ads conversion: ${conversionLabel}`);
  }
};
